import { IntentAnalysisRoot, ScreenRoot } from "types";

export const IntentAnalysisRootDefinition: ScreenRoot = {
  name: IntentAnalysisRoot,
  routePath: ["/dashboard/*"],
  accessPath: "campaign.intentAnalysisWithSpotlight",
};
